export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            联系我们
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            有任何关于<strong>免费漫画</strong>阅读的问题或建议，欢迎联系我们
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-100 rounded-xl p-5 md:p-6 text-center border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center mx-auto rounded-full bg-primary-100 text-primary-600 mb-3">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">business@chongchong.com</p>
            </div>
            <div className="bg-background-100 rounded-xl p-5 md:p-6 text-center border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center mx-auto rounded-full bg-accent-100 text-accent-600 mb-3">
                <i className="ri-edit-line text-lg"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-500">submit@chongchong.com</p>
            </div>
            <div className="bg-background-100 rounded-xl p-5 md:p-6 text-center border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center mx-auto rounded-full bg-secondary-100 text-secondary-600 mb-3">
                <i className="ri-question-line text-lg"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服支持</h3>
              <p className="text-xs text-foreground-500">support@chongchong.com</p>
            </div>
          </div>
          <div className="mt-8 bg-background-100 rounded-xl p-6 border border-background-200/60 text-center">
            <p className="text-sm text-foreground-600">
              您也可以通过<strong className="text-primary-500">官方微博</strong>和<strong className="text-primary-500">微信公众号</strong>关注虫虫漫画网，获取最新<strong>好看的漫画推荐</strong>和更新资讯。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}